export const adjustDuplicateCoordinates = (coordinatesArray) => {
    const seen = new Map();
    return coordinatesArray.map(coord => {
        const key = `${coord.lng},${coord.lat}`;
        if (seen.has(key)) {
            coord.lng += 0.0001 * seen.get(key);
            seen.set(key, seen.get(key) + 1);
        } else {
            seen.set(key, 1);
        }
        return coord;
    });
};